module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"categories":"Categories","explainer":"Explainer video","explainer_sub":"How to use bonkers.ie","latest":"Latest video","recent":"Recent videos"}}')
  delete Component.options._Ctor
}
